module.exports = __webpack_public_path__ + "img/icon-sb-in-home-drop-off-icon-100x67-v1.b81d3a2.svg";